'use strict';

module.exports = {
    MOBILE_TO_DESKTOP: 1000
};
